import { DatePicker } from 'antd';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';

export const DarwinDatePicker = DatePicker.generatePicker<Date>(
  dateFnsGenerateConfig
);
